import Vue from 'vue';
import VueRouter from 'vue-router';

const Login     = () => import('../views/login');
const LoginNew  = () => import('../views/login-new');
const Layout    = () => import('../views/layout');
const Welcome   = () => import('../views/welcome');
const Page      = () => import('../views/portal/page');
const App       = () => import('../views/portal/app');

Vue.use(VueRouter);

const routes = [{
    name: 'login',
    path: '/login',
    component: Login
}, {
    name: 'login-new',
    path: '/login-new',
    component: LoginNew
}, {
    name: 'layout',
    path: '/',
    component: Layout,
    // redirect: '/home',
    children: [{
        name: 'index',
        path: '',
        component: Welcome  // (resolve) => require(['../views/welcome'], resolve)
    }, {
        name: 'page',
        path: 'page',
        component: Page,
    }, {
        name: 'app',
        path: 'app',
        component: App,
    }, {
        name: 'my',
        path: 'my',
        component: Welcome,
    }, {
        name: 'sys',
        path: 'sys',
        component: Welcome,
    }]
}/*, {
    name: 'portal',
    path: '/portal',
    component: (resolve) => require(['../views/portal/portal'], resolve),
    children: [{
        name: 'welcome',
        path: '/welcome',
        component: (resolve) => require(['../views/portal/welcome'], resolve),
    }, {
        name: 'basic-role',
        path: 'basic/role',
        component: (resolve) => require(['../views/basic/role/role'], resolve),
    }, {
        name: 'basic-admin',projects
        path: 'basic/admin',
        component: (resolve) => require(['../views/basic/admin/admin'], resolve),
    }, {
        name: 'basic-profile',
        path: 'basic/profile',
        component: (resolve) => require(['../views/setting/profile'], resolve),
    }, {
        name: 'basic-project-profile',
        path: 'basic/project-profile',
        component: (resolve) => require(['../views/setting/project-profile'], resolve),
    }, {
        name: 'basic-quotes',
        path: 'basic/quotes',
        component: (resolve) => require(['../views/basic/quotes/list'], resolve),
    }, {
        name: 'basic-message',
        path: 'basic/message',
        component: (resolve) => require(['../views/basic/message/list'], resolve),
    }, {
        name: 'basic-tag',
        path: 'basic/tag',
        component: (resolve) => require(['../views/basic/tag/list'], resolve),
    }, {
        name: 'basic-webpage',
        path: 'basic/webpage',
        component: (resolve) => require(['../views/basic/webpage/pages'], resolve),
    }, {
        name: 'basic-page',
        path: 'basic/page',
        component: (resolve) => require(['../views/basic/page/pages'], resolve),
    }, {
        name: 'basic-report',
        path: 'basic/report',
        component: (resolve) => require(['../views/basic/report/list'], resolve),
    }, {
        name: 'basic-flow',
        path: 'basic/flow',
        component: (resolve) => require(['../views/flow/list'], resolve),
    }, {
        name: 'basic-mb',
        path: 'basic/mb',
        component: (resolve) => require(['../views/basic/mb/mb'], resolve),
    }, {
        name: 'basic-menus',
        path: 'basic/menus',
        component: (resolve) => require(['../views/basic/menus/menus'], resolve),
    }, {
        name: 'basic-dept',
        path: 'basic/dept',
        component: (resolve) => require(['../views/basic/dept/dept'], resolve),
    }, {
        name: 'portal-datas',
        path: 'datas/:contentId',
        component: (resolve) => require(['../views/data/datas'], resolve),
    }, {
        name: 'portal-iframe',
        path: 'iframe/:contentId',
        component: (resolve) => require(['../views/data/iframe'], resolve),
    }, {
        name: 'portal-jzlpage',
        path: 'jzlpage/:contentId',
        component: (resolve) => require(['../views/data/page'], resolve),
    }, {
        name: 'portal-forms',
        path: 'form/list',
        component: (resolve) => require(['../views/define-form/list'], resolve),
    }, {
        name: 'portal-form-create-type',
        path: 'form/create-sel-type',
        component: (resolve) => require(['../views/define-form/create-sel-type'], resolve),
    }, {
        name: 'portal-form-create',
        path: 'form/create',
        component: (resolve) => require(['../views/define-form/create'], resolve),
    }, {
        name: 'portal-workflow',
        path: 'workflow/list',
        component: (resolve) => require(['../views/flow/list'], resolve),
    }, {
        name: 'portal-judge-list',
        path: 'judge/list',
        component: (resolve) => require(['../views/judge/list'], resolve),
    }, {
        name: 'portal-judge-create',
        path: 'judge/create',
        component: (resolve) => require(['../views/judge/create'], resolve),
    }]
}*/];

const router = new VueRouter({
    // mode:'history', //这样url就没有/#/XXX,而是常见的url形式
    base: process.env.BASE_URL,
    routes:routes, // short for routes: routes
    linkActiveClass:'active',     //router-link的选中状态的class，也有一个默认的值
    // history:true
});

export default router
